@if (formGroup) {
  <div class="container" xmlns="http://www.w3.org/1999/html">
    <div class="row">
      <div class="col">
        <h3 class="mb-4">{{formGroup.name}}</h3>
        <div class="mb-5">{{formGroup.description}}</div>
        @let options = getOptions(formGroup);
        @if (options.length && getLinks(formGroup).length) {
          <h5>rbb Forms Formulare</h5>
        }
        <ul class="list-group list-group-flush no-marker mb-4">
          @for (option of options; track option.key) {
            <li>
              <a class="list-group-item list-group-item-action nav-link no-border" routerLink="/tag/{{option.key}}">
                <i class="far fa-file-alt"></i>&ensp;{{option.value}}
                  @if (isProductive(option.key, option.value)) {
                    <span class="badge bg-primary"><small>PROD</small></span>
                  }
              </a>
            </li>
          }
        </ul>
        @let links = getLinks(formGroup);
        @if (links.length) {
          <h5>Links zu weiteren Formularen</h5>
        }
        <ul class="list-group list-group-flush no-marker mb-4">
          @for (link of links; track link.key) {
            <li>
              <a class="list-group-item list-group-item-action nav-link no-border" [href]="link.key">
                <i class="far fa-file-alt"></i>&ensp;{{link.value}}&ensp;<sup><i class="fas fa-external-link-alt text-secondary d-inline-block small"></i></sup>
              </a>
            </li>
          }
        </ul>
        <a class="btn btn-danger" routerLink="/list"><i class="fas fa-arrow-left"></i>&ensp;Zurück</a>
      </div>
    </div>
  </div>
} @else {

  <div class="text-center m-auto mt-5">
    <rbb-loader/>
    <small class="text-secondary d-block">Formulargruppe wird geladen...</small>
  </div>
}
